import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CurrencyPipe } from '@angular/common';
import { Currency } from '../components/currency-selector/currency-country-codes';
import { isNumber } from 'mathjs';
import { CLDRService } from '../services/cldr/cldr.service';
import { UserSettingsQuery } from '../../features/user-settings/state/user-settings.query';
import { filterNilValue } from '@datorama/akita';

@Pipe({
    name: 'formatCurrency$',
    standalone: true
})
export class FormatCurrencyPipe implements PipeTransform {
    constructor(
        @Inject(LOCALE_ID) locale: string,
        private userSettingsQuery: UserSettingsQuery,
        private cldrService: CLDRService
    ) {
        //super(locale);
    }
    transform(
        number: number,
        currencyCode?: string | Currency,
        useShortNumberFormat: boolean = false,
        nullValue: string | number = 'n/a',
        overrideDigitsInfo?: string,
        transformSign: 'only-positive' | 'only-negative' = null
    ): Observable<string> {
        // E.g., we only want positive value
        if (!!transformSign) {
            number = Math.abs(number);
            number = transformSign === 'only-positive' ? number : -1 * number;
        }
        const numberOfDigits = (Math.log(Math.abs(number)) * Math.LOG10E + 1) | 0;
        let obs$: Observable<[number, number]>;
        if (numberOfDigits <= 3) {
            obs$ = this.userSettingsQuery.selectGlobalSetting$('DIGITS_SMALL');
        } else {
            obs$ = this.userSettingsQuery.selectGlobalSetting$('DIGITS_LARGE');
        }
        const display$ = this.userSettingsQuery.selectGlobalSetting$('CURRENCY_SYMBOL');
        const baseCurrency$ =
            this.userSettingsQuery.selectGlobalSetting$('BASE_CURRENCY');

        if (!number && !isNumber(nullValue)) {
            return of(nullValue);
        }

        if (useShortNumberFormat) {
            return combineLatest([baseCurrency$, display$, obs$]).pipe(
                map(([baseCurrency, display, digits]) => {
                    return this.cldrService.formatShortCurrency(
                        number,
                        (currencyCode || baseCurrency) as Currency,
                        display,
                        digits
                    );
                })
            );
        } else {
            return combineLatest([
                this.userSettingsQuery.selectGlobalSetting$('LOCALE'),
                obs$.pipe(
                    filterNilValue(),
                    map((digits) => '1.' + digits.join('-'))
                ),
                display$,
                baseCurrency$
            ]).pipe(
                map(([locale, digitsInfo, display, baseCurrency]) => {
                    //super.transform(number, currencyCode, display, digitsInfo, locale)
                    return new CurrencyPipe(locale).transform(
                        number,
                        currencyCode || baseCurrency,
                        display,
                        overrideDigitsInfo || digitsInfo,
                        locale
                    );
                })
            );
        }
    }
}
